/**
 * Shape predicate for material-graph JSON dumps. Lives in its own
 * file so callers can check whether an arbitrary properties.json
 * looks material-shaped without dragging in the heavy @xyflow/react
 * runtime that MaterialGraph.tsx pulls in. That distinction is what
 * lets the rest of the dashboard lazy-load MaterialGraph without
 * paying its chunk cost upfront.
 */

function isObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export function looksLikeMaterialGraph(data: unknown): boolean {
  if (!Array.isArray(data)) return false;
  return data.some(
    (e) =>
      isObject(e) &&
      typeof e.Type === 'string' &&
      e.Type.startsWith('MaterialExpression'),
  );
}
